import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Location } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  private _http = inject(HttpClient);

  fetchLocations(): Observable<Location[]> {
    return this._http.get<Location[]>(`/locations`);
  }
}
